var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLCollapse",
    {
      staticClass: "vendor-contacts",
      attrs: { title: _vm.$t("vendor.contacts") },
    },
    [
      _c(
        "div",
        {
          staticClass: "vendor-contacts__table",
          attrs: { slot: "content" },
          slot: "content",
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("label", { staticClass: "column" }, [
              _vm._v(_vm._s(_vm.$t("vendor.allContacts"))),
            ]),
            _vm._v(" "),
            _vm.canManageAllContacts
              ? _c("div", { staticClass: "column" }, [
                  _c(
                    "div",
                    { staticClass: "row action-bar align-right" },
                    [
                      !_vm.editStatus
                        ? _c("HKLButton", {
                            attrs: { color: "orange", action: "edit" },
                            on: { click: _vm.chnageEditStatus },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.editStatus
                        ? [
                            _c("HKLButton", {
                              attrs: { color: "darkblue", action: "cancel" },
                              on: { click: _vm.cancel },
                            }),
                            _vm._v(" "),
                            _c("HKLButton", {
                              attrs: { color: "orange", action: "save" },
                              on: { click: _vm.save },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("HKLTable", {
            ref: "vendorContactsTable",
            attrs: {
              dataSource: _vm.dataSrc,
              columns: _vm.columns,
              filterBar: false,
              onFilter: false,
            },
          }),
          _vm._v(" "),
          _vm.editStatus && _vm.canManageAllContacts
            ? _c("LinkCcdContactButton", {
                attrs: { queryParams: _vm.linkBtnQueryParams },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }